import React from 'react';
import { motion } from 'framer-motion';
import { Crown, X, Check } from 'lucide-react';
export function ProElite() {
  return <section className="py-10 sm:py-16 lg:py-24 bg-indigo-50 border-b border-indigo-100" data-id="element-179">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180">
        <div className="text-center mb-8 sm:mb-16" data-id="element-181">
          <div className="inline-flex items-center justify-center p-2 sm:p-3 bg-brand-dark rounded-full mb-4 sm:mb-6" data-id="element-182">
            <Crown className="w-6 h-6 sm:w-10 sm:h-10 text-brand-accent" data-id="element-183" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold mb-2 sm:mb-4 text-[#214B95]" data-id="element-184">
            ¿QUÉ AGREGA EL PAQUETE PRO ÉLITE™?
          </h2>
          <p className="text-sm sm:text-xl text-gray-600 font-medium" data-id="element-185">
            Para profesionales que quieren ir un paso más allá (Empresas de
            Construcción o Coaching de Negocios)
          </p>
        </div>

        <div className="bg-brand-bg rounded-xl sm:rounded-2xl p-5 sm:p-8 md:p-12 border border-gray-200 mb-8 sm:mb-12" data-id="element-186">
          <h3 className="text-xl sm:text-2xl font-bold text-brand-dark mb-6 sm:mb-8 text-center" data-id="element-187">
            Rompé la meseta del profesional independiente
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8" data-id="element-188">
            <div className="bg-white p-4 sm:p-6 rounded-xl border border-gray-100 shadow-sm" data-id="element-189">
              <div className="flex items-center mb-3 sm:mb-4" data-id="element-190">
                <X className="w-5 h-5 sm:w-6 sm:h-6 text-red-500 mr-2" data-id="element-191" />
                <h4 className="font-bold text-gray-500 text-sm sm:text-base" data-id="element-192">
                  Sin Pro Élite:
                </h4>
              </div>
              <p className="text-xs sm:text-base text-gray-600 leading-relaxed" data-id="element-193">
                Seguís dependiendo únicamente de tu tiempo físico para generar
                ingresos, compitiendo por precio bajo contra albañiles
                informales.
              </p>
            </div>

            <div className="bg-brand-dark p-4 sm:p-6 rounded-xl shadow-md" data-id="element-194">
              <div className="flex items-center mb-3 sm:mb-4" data-id="element-195">
                <Check className="w-5 h-5 sm:w-6 sm:h-6 text-brand-accent mr-2" data-id="element-196" />
                <h4 className="font-bold text-white text-sm sm:text-base" data-id="element-197">
                  Con Pro Élite:
                </h4>
              </div>
              <p className="text-xs sm:text-base text-gray-300 leading-relaxed" data-id="element-198">
                Aprendés a estructurar un modelo de negocio escalable, delegar
                presupuestos y vender consultorías de diseño costosas antes de
                la obra.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-4 sm:space-y-6" data-id="element-199">
          <h3 className="text-lg sm:text-xl font-bold text-brand-dark mb-4 sm:mb-6 uppercase tracking-wide text-center sm:text-left" data-id="element-200">
            EL CONTENIDO COMPLETO PRO ÉLITE™ INCLUYE:
          </h3>

          <motion.div initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex items-start bg-white p-4 sm:p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-201">
            <span className="bg-brand-accent text-brand-dark font-black px-2 py-1 sm:px-3 sm:py-1 rounded-md mr-3 sm:mr-4 mt-0.5 sm:mt-1 text-xs sm:text-base" data-id="element-202">
              M1
            </span>
            <div data-id="element-203">
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed" data-id="element-204">
                <strong className="text-brand-dark" data-id="element-205">
                  Sistema de Programación y Costos de Élite:
                </strong>{' '}
                Cómo calcular el rendimiento exacto de tus cuadrillas, optimizar
                la compra de materiales en corralones y proteger tu margen neto
                de ganancia ante la inflación.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex items-start bg-white p-4 sm:p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-206">
            <span className="bg-brand-accent text-brand-dark font-black px-2 py-1 sm:px-3 sm:py-1 rounded-md mr-3 sm:mr-4 mt-0.5 sm:mt-1 text-xs sm:text-base" data-id="element-207">
              M2
            </span>
            <div data-id="element-208">
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed" data-id="element-209">
                <strong className="text-brand-dark" data-id="element-210">
                  El Negocio del Entrenamiento y Asesoría Comercial:
                </strong>{' '}
                Cómo convertir tu conocimiento técnico en un servicio de
                dirección de obra digital, vendiendo asesorías online de
                remodelación a todo el país.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}